import { render, staticRenderFns } from "./ModalRecebimentoPg.vue?vue&type=template&id=2515f0b9&scoped=true&"
import script from "./ModalRecebimentoPg.vue?vue&type=script&lang=js&"
export * from "./ModalRecebimentoPg.vue?vue&type=script&lang=js&"
import style0 from "./ModalRecebimentoPg.vue?vue&type=style&index=0&id=2515f0b9&scoped=true&lang=css&"
import style1 from "./ModalRecebimentoPg.vue?vue&type=style&index=1&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2515f0b9",
  null
  
)

export default component.exports